import Basic from './basic.vue';
import MobBasic from './mob-basic.vue';

export const componentMap = {
	basic: Basic,
	'basic-mobile': MobBasic
};
